<template>
  <div class="of-content-4">
    <topper :view="ofContent4.topper" />
    <div class="content">
      <item v-for="(item, index) in ofContent4.trainings" :key="index" :userTest="userTest" :view="item" />
    </div>
  </div>
</template>


<script>
  import item from "./item.vue"
  import topper from "./topper.vue"

  export default {
    name: "of-content-4",
      props: {
          view: {
              type: Object,
          },
          userTest: {
              type: Boolean,
          }
      },
    components: {
      "item": item,
      "topper": topper
    },
    data() {
      return {
        topper: {
          title1: '40+',
          title2: 'Tools',
          text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!',
          imgLeftPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-left.svg',
          imgRightPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-right.svg'
        },
        trainings: [
          /* linha 1 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-cheetah-website-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'Cheetah Drag & Drop Website Builder',
            baIntelligenceTag: 'fc-c4-cheetah-website-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-canvas.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'Builderall canvas',
            baIntelligenceTag: 'fc-c4-cheetah-builderall-canvas'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-mailing-boss.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'Mailing Boss',
            baIntelligenceTag: 'fc-c4-mailing-boss'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-funnel-club.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'Funnel Club',
            baIntelligenceTag: 'fc-c4-funnel-club'
          },

          /* linha 2 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-telegram.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'Telegram',
            baIntelligenceTag: 'fc-c4-telegram'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-dns-manager.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'DNS Manager',
            baIntelligenceTag: 'fc-c4-dns-manager'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-booking.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'Builderall Booking',
            baIntelligenceTag: 'fc-c4-booking-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-app-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'App builder',
            baIntelligenceTag: 'fc-c4-app-builder'
          },

          /* linha 3 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-magazine-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'Builderall Unlimited magazine builder',
            baIntelligenceTag: 'fc-c4-magazine-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-wp3-click-integration.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'Wordpress 3-click integration',
            baIntelligenceTag: 'fc-c4-wordpress-integration'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-ecommerce.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: '',
            baIntelligenceTag: 'fc-c4-ecommerce-magento'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-directory-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'builderall directory builder',
            baIntelligenceTag: 'fc-c4-directory-builder'
          },

          /* linha 4 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-mockup-studio.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'mockup studio',
            baIntelligenceTag: 'fc-c4-mockup-studio'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-funnel-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'video funnel builder',
            baIntelligenceTag: 'fc-c4-video-funnel-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-tag-tool.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'video tag tool',
            baIntelligenceTag: 'fc-c4-video-tag-tool'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-video-hosting.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'builderall video hosting',
            baIntelligenceTag: 'fc-c4-video-hosting'
          },

          /* linha 5 */
          {
              path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-3d-photo-editor-studio.svg',
              path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
              link: '#',
              borderClass: 'border1',
              borderClassV5: 'border5',
              title: '3d photo editor studio',
              baIntelligenceTag: 'fc-c4-animated-vsl-video-builder'
          },
          {
              path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-animate-vsl-video.svg',
              path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
              link: '#',
              borderClass: 'border2',
              borderClassV5: 'border5',
              title: 'animate vsl video',
              baIntelligenceTag: 'fc-c4-transparent-floating-videos'
          },
          {
              path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-browser-notification-app.svg',
              path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
              link: '#',
              borderClass: 'border3',
              borderClassV5: 'border5',
              title: 'browser notification app',
              baIntelligenceTag: 'fc-c4-browser-notifications'
          },
          {
              path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-seo-on_report-app.svg',
              path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
              link: '#',
              borderClass: 'border4',
              borderClassV5: 'border5',
              title: 'seo on-report app',
              baIntelligenceTag: 'fc-c4-page-seo-report'
          },

          /* linha 6 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-click-map.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'click map',
            baIntelligenceTag: 'fc-c4-new-clickmap'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-social-autopost-app.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'social autopost app',
            baIntelligenceTag: 'fc-c4-social-autopost-app'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-messenger-chatbot.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'professional messenger chatbot',
            baIntelligenceTag: 'fc-c4-messenger-chatbot'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-share-locker.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'share locker',
            baIntelligenceTag: 'fc-c4-facebook-viral-share-locker'
          },

          /* linha 7 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-chatbuilder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'new chatbuilder',
            baIntelligenceTag: 'fc-c4-script-generator-new-chat-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-elearning.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'new elearning',
            baIntelligenceTag: 'fc-c4-elearning'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-script-generator.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'script generator',
            baIntelligenceTag: 'fc-c4-script-generator-copywriting'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-wrapper.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'video wrapper',
            baIntelligenceTag: 'fc-c4-video-wrapper'
          },

          /* linha 8 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-instagram-autoresponder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'instagram autoresponder',
            baIntelligenceTag: 'fc-c4-instagram-autoresponder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-sms-messaging.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'sms messaging',
            baIntelligenceTag: 'fc-c4-sms messaging'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-webinar-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'builderall webinar builder',
            baIntelligenceTag: 'fc-c4-webinar builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-va-access.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'va acess',
            baIntelligenceTag: 'fc-c4-va-access'
          },

          /* linha 9 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-email.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'professional email',
            baIntelligenceTag: 'fc-c4-professional-emails'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-website-bot.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'professional website bot',
            baIntelligenceTag: 'fc-c4-website-chat-bot'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-crm.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'crm',
            baIntelligenceTag: 'fc-c4-crm'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-marketplace.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'marketplace',
            baIntelligenceTag: 'fc-c4-marketplace'
          },

          /* linha 10 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-cheetah-funnel-builder.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'cheetah funnel builder',
            baIntelligenceTag: 'fc-c4-funnel-builder'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-design-resource.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border2',
            borderClassV5: 'border5',
            title: 'design resource',
            baIntelligenceTag: 'fc-c4-design-resource'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-market-place.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border3',
            borderClassV5: 'border5',
            title: 'new market place',
            baIntelligenceTag: 'fc-c4-supercheckout-intern'
          },
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-website-agency.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border4',
            borderClassV5: 'border5',
            title: 'website agency',
            baIntelligenceTag: 'fc-c4-website-agency'
          },

          /* linha 11 */
          {
            path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-social-proof-pop_up.svg',
            path_new: '/internacional/public/office5/img/tools/default/cheetah_builder.svg',
            link: '#',
            borderClass: 'border1',
            borderClassV5: 'border5',
            title: 'new social proof pop-up',
            baIntelligenceTag: 'fc-c4-social-proof-pop-up'
          }
        ]
      }
    },
    computed: {
        ofContent4: function () {
            return (this.view !== undefined && this.view !== null) ? this.view : this.$data
        }
    },
    created() {
        console.log(this.view)
    },
    mounted() {}
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../../../../scss/office";

  .of-content-4 {
    font: inherit;

    border-radius: 0.4em; /*4px */
    margin-bottom: 2.4em!important; /* 24px */
    background-color: $of-color3;

    .content {
      font: inherit;

      display: grid;
      row-gap: 2.4em; /* 24px */
      column-gap: 4.5em; /* 45px */
      grid-template-columns: repeat(auto-fill, minmax(22.4em, 1fr)); /* 224px */

      transition: all .5s ease;

      padding: 6em 9.4em 17.8em 9.4em; /* 60px 94px 178px 94px */
    }
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-4/index.vue